export default "__VITE_ASSET__CfUK6Cqh__"